export interface GeographicalRegion {
    id: number | null;
    name: string;
    code: string;
    number: string;
    longitude: number | null;
    latitude: number | null;
    utilityId: number;
}

export function getInitGeographicalRegion(): GeographicalRegion {
    return {
        id: null,
        name: '',
        code: '',
        number: '',
        longitude: 0,
        latitude: 0,
        utilityId: 0,
    };
}